module.exports = __webpack_public_path__ + "img/H02027-38.b9c17528.jpg";